import { masker } from './masker';

const cpfMask = masker({
  masked: {
    mask: '000.000.000-00',
    transform: (value: string) => {
      return cpfMask.unmask(value);
    },
    maskDefault: (value: string) => {
      return cpfMask.mask(value);
    },
  },
});

export { cpfMask };
